import React from "react";

export const ExerciseFreeFormId = "b98a090a-cfe5-11e7-8431-a3ea0bef72c5";

export const AdminIdTS  = "9a7af3c4-97b1-11e7-9e5d-f78105fd617e";
export const AdminIdASP = "6d226cf8-fedd-4e72-b892-38dac02aedbc";


export const TS_LU  = "29f05c50-b2ab-11e8-9392-cdc36ab27e5a";
export const TS_JC  = "520b3da0-b2a0-11e8-aead-efe3b60561d4";
export const TS_ASP = "b569d320-5c19-11e9-bda3-8726ddea8a40";



// WEBPACK FOOTER //
// ./src/utils/StaticIds.js